import { Button, Form, Col, Offcanvas } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import WebService from "../../../utility/WebService";
import { Label } from "../../../components/Label/Label";

interface PropData {
    isShow: boolean;
    isClose: Function;
    uuid: string;
}

const ChangePassword = (props: PropData) => {
    const { handleSubmit, formState: { errors }, control, watch, getValues, register, reset } = useForm<any>({});
    const watchAllFields = watch();
    const passwordRegex = /^^(?=.*[A-Za-z0-9])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,20}$/;
    const [isShowNewPassword, setIsShowNewPassword] = useState<boolean>(false);
    const [isShowConfirmPassword, setIsShowConfirmPassword] = useState<boolean>(false);

    useEffect(() => {
        reset();
    }, [props.isShow]);

    const handlePasswordChange = (data: any) => {
        var obj = { uuid: props.uuid, password: data.password };
        WebService.postAPI({
            action: `user/change-password`,
            body: obj,
            id: "changePassword-btn",
        })
            .then((res: any) => {
                toast.success(res.message, { theme: "colored" });
                closeModal();
            })
            .catch(() => { });
    };

    const closeModal = () => {
        reset();
        props.isClose();
    };

    return (
        <>
            <Offcanvas show={props.isShow} onHide={props.isClose} placement="end">
                <Offcanvas.Header closeButton><Offcanvas.Title>Reset Password</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <form className="form-style" onSubmit={handleSubmit(handlePasswordChange)}  >
                        <Col lg={12} className="mb-3">
                            {/* Password */}
                            <Form.Label> Password</Form.Label>
                            <Controller
                                control={control}
                                name="password"
                                rules={{
                                    required: "Please Enter Password",
                                    pattern: {
                                        value: passwordRegex,
                                        message: "Between 8 to 20 characters and at least one upper case, lower case, number and special character.",
                                    },
                                }}
                                render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                    <div className="form-group mb-2">
                                        <div className="input-group mb-2">
                                            <input
                                                type={isShowNewPassword ? "text" : "password"}
                                                className="form-control border-end-0 border-start-0"
                                                placeholder="Password"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                            />
                                            <span
                                                className="input-group-text text-secondary bg-white border-start-0 cursor-pointer"
                                                onClick={() => setIsShowNewPassword(!isShowNewPassword)}
                                            >
                                                {isShowNewPassword ? (
                                                    <BsEyeSlash size={16} />
                                                ) : (
                                                    <BsEye size={16} />
                                                )}
                                            </span>
                                        </div>
                                        {(errors["password"]?.message ||
                                            Boolean(errors["password"]?.message) ||
                                            (isTouched && !watchAllFields.password) ||
                                            (watchAllFields.password &&
                                                !passwordRegex.test(watchAllFields.password))) && (
                                                <div className="login-error">
                                                    <Label
                                                        title={
                                                            errors.password?.message || watchAllFields.password
                                                                ? "Between 8 to 20 characters and at least one upper case, lower case, number and special character."
                                                                : "Please Enter Password."
                                                        }
                                                        modeError={true}
                                                    />
                                                </div>
                                            )}
                                    </div>
                                )}
                            />
                        </Col>

                        <Col lg={12} className="mb-2 me-4">
                            {/* Confirm Password */}
                            <Form.Label>Confirm Password</Form.Label>

                            <Controller
                                control={control}
                                name="comfirm_password"
                                rules={{
                                    required: "Please Enter Password",
                                    validate: (value: any) => {
                                        const { password } = getValues();
                                        return password === value || "Passwords must match";
                                    },
                                }}
                                render={({
                                    field: { onChange, onBlur },
                                    fieldState: { isTouched },
                                }) => (
                                    <div className="mb-3">
                                        <div className="input-group mb-2">
                                            <input
                                                type={isShowConfirmPassword ? "text" : "password"}
                                                className="form-control border-end-0 border-start-0"
                                                placeholder="Confirm Password"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                            />
                                            <span
                                                className="input-group-text text-secondary bg-white border-start-0 cursor-pointer"
                                                onClick={() =>
                                                    setIsShowConfirmPassword(!isShowConfirmPassword)
                                                }
                                            >
                                                {isShowConfirmPassword ? (
                                                    <BsEyeSlash size={16} />
                                                ) : (
                                                    <BsEye size={16} />
                                                )}
                                            </span>
                                        </div>
                                        {(errors["comfirm_password"]?.message ||
                                            Boolean(errors["comfirm_password"]?.message) ||
                                            (isTouched && !watchAllFields.comfirm_password) ||
                                            (watchAllFields.comfirm_password &&
                                                watchAllFields.password !=
                                                watchAllFields.comfirm_password)) && (
                                                <div className="login-error">
                                                    <Label
                                                        title={
                                                            errors.comfirm_password?.message ||
                                                                watchAllFields.comfirm_password
                                                                ? "Passwords Must Match"
                                                                : "Please Enter Confirm Password."
                                                        }
                                                        modeError={true}
                                                    />
                                                </div>
                                            )}
                                    </div>
                                )}
                            />
                        </Col>
                        <div className="text-center">
                            <Button
                                variant="dark"
                                className="btn-brand-1 px-5 mt-3 mb-3"
                                type="submit"
                                id="changePassword-btn"
                            >
                                Save
                            </Button>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default ChangePassword;
